/** Адрес API (пусто: тот же origin). Один источник для apiClient и запросов чистым axios. */
export const API_BASE_URL: string = import.meta.env.VITE_API_URL || '';
